<template>
  <TwoColumnsPageContainer side-top="contact">
    <SellFormCasavo slot="side" />

    <div slot="body" class="text-black-light">
      <p class="text-lg md:text-xl mb-16">
        La <strong>valutazione del tuo immobile</strong> è un aspetto
        fondamentale per vendere al giusto prezzo. Con UniCredit RE Services
        scopri subito <strong>quanto vale la tua casa</strong> e puoi contare su
        un <strong>supporto professionale</strong> per una
        <strong>vendita in tranquillità</strong>.
      </p>

      <h2 class="section-headline my-8 md:my-16">
        Perché valutare casa con UniCredit RE Services ti conviene?
      </h2>

      <div class="gap-y-8 sm:gap-y-16 grid grid-cols-1 sm:grid-cols-3 gap-x-13">
        <IconCard
          v-for="(item, idx) in steps"
          :key="`IconCard_${idx}`"
          :icon="item.icon"
          :title="item.title"
          :content="item.content"
        />
      </div>
    </div>

    <template slot="footer">
      <div class="mt-20">
        <h2 class="section-headline mt-8 mb-4 md:mt-16 md:mb-8">
          Domande frequenti
        </h2>
        <h3 class="subtitle">
          Perché valutare casa con UniCredit RE Services?
        </h3>
        <p class="mb-6">
          Con noi il processo di valutazione della tua casa è accurato e
          professionale, grazie ad una profonda conoscenza del mercato unita
          alla tecnologia Casavo e l'utilizzo di strumenti digitali evoluti.
          Siamo l'agenzia immobiliare di UniCredit: mettiamo al servizio dei
          nostri clienti e delle loro esigenze immobiliari la serietà e la
          professionalità del Gruppo.
        </p>
        <h3 class="subtitle">
          Come posso richiedere una prima valutazione del mio immobile?
        </h3>
        <p class="mb-6">
          Puoi ricevere subito una prima stima inserendo nel form l'indirizzo
          dell'immobile che vuoi valutare.
        </p>
        <h3 class="subtitle">Cos'è il Report Valore Casa?</h3>
        <p class="mb-6">
          Si tratta di un documento completo che analizza i diversi fattori
          interni ed esterni legati alla casa per calcolarne il prezzo corretto
          per il mercato.
        </p>
        <h3 class="subtitle">
          Dopo la valutazione, potete aiutarmi anche a vendere casa?
        </h3>
        <p class="mb-6">
          Certo. Siamo al tuo fianco per dare massima visibilità al tuo immobile
          attraverso la promozione sui principali portali immobiliari e su
          YouTube, visite virtuali, *servizi fotografici professionali e
          planimetrie arredate.
        </p>
      </div>
      <div class="my-16">
        <SellDisclaimer :ape="false" />
        <p class="mt-4 text-xs font-sans">
          * Servizi a pagamento: costo indicativo per i servizi fotografici 94€
          + IVA, planimetrie arredate fino 100 m<sup>2</sup> 40€ + IVA.
        </p>
      </div>

      <StripBanner
        class="mb-20"
        btn-text="Scopri perché sceglierci"
        link="/vendo"
      >
        Cerchi un supporto professionale per vendere il tuo immobile?
      </StripBanner>
    </template>
  </TwoColumnsPageContainer>
</template>

<script>
// Components
import IconCard from '~/components/IconCard.vue'
import SellDisclaimer from '~/components/SellDisclaimer.vue'
import SellFormCasavo from '~/components/SellFormCasavo.vue'
import StripBanner from '~/components/StripBanner.vue'
import TwoColumnsPageContainer from '~/components/TwoColumnsPageContainer.vue'

export default {
  components: {
    IconCard,
    SellDisclaimer,
    SellFormCasavo,
    StripBanner,
    TwoColumnsPageContainer,
  },
  computed: {
    steps() {
      return [
        {
          title: 'Valutazione immobiliare online immediata',
          icon: 'finger-touch-bg-round',
          content: (
            <p>
              Ti basterà inserire poche semplici informazioni come l'indirizzo,
              la tipologia d'immobile e l'anno di costruzione per{' '}
              <strong>
                ricevere subito la valutazione preliminare gratuita grazie alla
                tecnologia di Casavo.
              </strong>
              <sup>1</sup>
            </p>
          ),
        },
        {
          title: 'Stima immobiliare personalizzata',
          icon: 'house-door-bg-round',
          content: (
            <p>
              Dopo aver ricevuto la valutazione online,{' '}
              <strong>
                un Consulente esperto della tua zona effettuerà un sopralluogo
              </strong>{' '}
              e realizzerà il{' '}
              <a
                class="text-blue"
                href="/assets/pdf/facsimile-reportvalorecasa.pdf"
                target="_blank"
              >
                <strong>Report Valore Casa</strong>
              </a>
              <sup>2</sup>, un documento personalizzato sulle caratteristiche
              del tuo immobile.
            </p>
          ),
        },
        {
          title: 'Consulente immobiliare vicino a te',
          icon: 'advisor-bg-round',
          content: (
            <p>
              Il contatto diretto con un professionista della tua zona ti
              permetterà non solo di ricevere una valutazione del valore di
              mercato, ma anche{' '}
              <strong>
                assistenza lungo tutto il processo di compravendita
              </strong>
              .
            </p>
          ),
        },
      ]
    },
  },
}
</script>
